<template>
  <div v-if="isMinimize && !isTempHidden">
    <component v-if="message" :is="type" :message="message" :sent="sent" :hide="hide" :options="options" @close="close" @click="toggleMinimize"></component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Simple from './notifications/Simple.vue'
import Grabber from './notifications/Grabber.vue'
// NOTE: The commented parts of the file are provided for handling chrome autoplay block 
// import canAutoPlay from 'can-autoplay'

export default {
  components: {
    Simple,
    Grabber
  },
  // mounted() {
  //   if (!this.isMute) {
  //     canAutoPlay.audio().then(({result}) => {
  //       if (result === false ) this.hasUserGesture = false;  // cannot autoplay
  //     })
  //   }
  // },
  data() {
    return {
      hide: false,
      // hasUserGesture: true
    }
  },
  watch: {
    message(newMsg) {
      this.hide = false
    },
    isMinimize(v) {
      if (!v)
        this.hide = false
    }
  },
  computed: {
    options() {
      return this.getNewMessage && this.getNewMessage.grabber ? this.getNewMessage.grabber : {}
    },
    type() {
      return this.getNewMessage && this.getNewMessage.grabber ? 'Grabber' : 'Simple'
    },
    message() {
      // if (!this.hasUserGesture) return 'Click here to unmute.';
      return this.getNewMessage ? this.getNewMessage.message : ''
    },
    sent() {
      return this.getNewMessage ? moment(this.getNewMessage.created_at).fromNow() : ''
    },
    key() {
      return this.getNewMessage ? this.getNewMessage.msgKey : ''
    },
    ...mapGetters([
      'getNewMessage',
      'isMinimize',
      'isTempHidden',
      // 'isMute'
    ])
  },
  methods: {
    close() {
      this.hide = true
      if (this.key)
        this.$store.dispatch('markAsRead', this.key)
    },
    toggleMinimize() {
      this.$store.dispatch('toggleMinimize')
      // this.hasUserGesture = true;
    }
  }
}

</script>
